"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvalidFreeTrialLineItems = exports.anyNonEligibleLineItemsInCart = exports.getNonFreeTrialEligibleCartLineItems = exports.getCTProductFreeTrialVariant = exports.isProductItemFreeTrial = exports.getFreeTrialPeriodEndDate = exports.getFreeTrialPeriod = exports.isLineItemPotentialFreeTrial = exports.isFreeTrial = exports.isLineItemFreeTrial = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const moment_1 = __importDefault(require("moment"));
const getProductUrl_1 = require("../product/getProductUrl");
const isLineItemFreeTrial = (lineItem) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const isCTItem = isCommerceType(lineItem);
    const variantAttributes = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes;
    const purchaseType = (_c = (_b = lineItem.custom) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.purchase_type;
    const period = isCTItem
        ? getAttributeByName('freeTrialTerm', variantAttributes) || 0
        : ((_e = (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.freeTrialTerm) || 0;
    const isEligible = isCTItem
        ? Boolean(getAttributeByName('freeTrialEligible', variantAttributes))
        : Boolean((_g = (_f = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.freeTrialEligible);
    return (0, exports.isFreeTrial)(purchaseType, period, isEligible);
};
exports.isLineItemFreeTrial = isLineItemFreeTrial;
const isFreeTrial = (purchaseType, freeTrialPeriod, isEligible) => {
    return purchaseType === mxp_schemas_1.Product.FreeTrials.FREE_TRIAL && freeTrialPeriod > 0 && isEligible;
};
exports.isFreeTrial = isFreeTrial;
const isLineItemPotentialFreeTrial = (item) => { var _a, _b; return ((_b = (_a = item.custom) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.purchase_type) === mxp_schemas_1.Product.FreeTrials.FREE_TRIAL; };
exports.isLineItemPotentialFreeTrial = isLineItemPotentialFreeTrial;
const getFreeTrialPeriod = (lineItem) => {
    var _a, _b, _c;
    if (!(0, exports.isLineItemFreeTrial)(lineItem))
        return 0;
    const isCTItem = isCommerceType(lineItem);
    const variantAttributes = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes;
    return isCTItem
        ? getAttributeByName('freeTrialTerm', variantAttributes)
        : ((_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.freeTrialTerm) || 0;
};
exports.getFreeTrialPeriod = getFreeTrialPeriod;
const getFreeTrialPeriodEndDate = (lineItem) => {
    const freeTrialPeriod = (0, exports.getFreeTrialPeriod)(lineItem);
    return (0, exports.isLineItemFreeTrial)(lineItem) ? (0, moment_1.default)().add(freeTrialPeriod, 'days') : null;
};
exports.getFreeTrialPeriodEndDate = getFreeTrialPeriodEndDate;
const getAttributeByName = (attributeName, attributes) => {
    const foundAttribute = attributes.find((a) => a.name === attributeName) || {};
    if (typeof (foundAttribute === null || foundAttribute === void 0 ? void 0 : foundAttribute.value) === 'boolean')
        return foundAttribute.value;
    return (foundAttribute === null || foundAttribute === void 0 ? void 0 : foundAttribute.value) || '';
};
const isCommerceType = (lineItem) => { var _a; return Array.isArray((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes); };
const isProductItemFreeTrial = (i) => ((i === null || i === void 0 ? void 0 : i.isFreeTrial) && (i === null || i === void 0 ? void 0 : i.freeTrialTerm) > 0) || false;
exports.isProductItemFreeTrial = isProductItemFreeTrial;
const getCTProductFreeTrialVariant = (product) => {
    var _a;
    return ((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.find((variant) => (variant === null || variant === void 0 ? void 0 : variant.freeTrialEligible) &&
        (variant === null || variant === void 0 ? void 0 : variant.freeTrialTerm) &&
        variant.prices.some(price => { var _a, _b; return (_b = (_a = price === null || price === void 0 ? void 0 : price.channel) === null || _a === void 0 ? void 0 : _a.applicableUserRoles) === null || _b === void 0 ? void 0 : _b.includes(mxp_schemas_1.User.MembershipIdsEnum.FREE_TRIAL); }))) || null;
};
exports.getCTProductFreeTrialVariant = getCTProductFreeTrialVariant;
const getNonFreeTrialEligibleCartLineItems = (lineItems) => {
    return lineItems.reduce((acc, lineItem) => {
        var _a, _b;
        const purchaseType = (_b = (_a = lineItem.custom) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.purchase_type;
        if (!(0, exports.isLineItemFreeTrial)(lineItem) && purchaseType === mxp_schemas_1.Product.FreeTrials.FREE_TRIAL) {
            acc.push({
                productId: lineItem.productId,
                productName: lineItem.name,
                productUrl: (0, getProductUrl_1.getLineItemProductUrl)(lineItem),
            });
        }
        return acc;
    }, []);
};
exports.getNonFreeTrialEligibleCartLineItems = getNonFreeTrialEligibleCartLineItems;
const anyNonEligibleLineItemsInCart = (lineItems) => Boolean((0, exports.getNonFreeTrialEligibleCartLineItems)(lineItems).length);
exports.anyNonEligibleLineItemsInCart = anyNonEligibleLineItemsInCart;
const getInvalidFreeTrialLineItems = (lineItemsToValidate, historicalLineItems) => {
    const today = (0, moment_1.default)();
    const { CANCELLED_AND_DEPROVISIONED, FAILED, DEPROVISIONED_EXPIRED, DEPROVISIONED_CANCELLED } = mxp_schemas_1.Orders.LineItemStates;
    const inactiveLineItemStates = [CANCELLED_AND_DEPROVISIONED, FAILED, DEPROVISIONED_EXPIRED, DEPROVISIONED_CANCELLED];
    const historicalProductSkus = historicalLineItems.reduce((acc, item) => {
        if ((0, moment_1.default)(item.custom.fields.access_end_datetime).isAfter(today)) {
            const isValidStatus = !inactiveLineItemStates.includes(item.state);
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            item.custom.fields.purchase_type === mxp_schemas_1.Product.FreeTrials.FREE_TRIAL
                ? isValidStatus
                    ? acc.activeFreeTrialSkus.add(item.variant.sku)
                    : acc.exFreeTrialSkus.add(item.variant.sku)
                : isValidStatus && acc.activeProductsSkus.add(item.variant.sku);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            item.custom.fields.purchase_type === mxp_schemas_1.Product.FreeTrials.FREE_TRIAL ||
                item.custom.fields.purchase_type === mxp_schemas_1.Product.FreeTrials.FREE_TRIAL_FULL
                ? acc.exFreeTrialSkus.add(item.variant.sku)
                : acc;
        }
        return acc;
    }, { activeFreeTrialSkus: new Set(), exFreeTrialSkus: new Set(), activeProductsSkus: new Set() });
    return lineItemsToValidate.reduce((acc, itemToValidate) => {
        if (!(0, exports.isLineItemPotentialFreeTrial)(itemToValidate))
            return acc;
        if (historicalProductSkus.activeFreeTrialSkus.has(itemToValidate.variant.sku)) {
            acc.activeFreeTrials.push(itemToValidate);
        }
        if (historicalProductSkus.activeProductsSkus.has(itemToValidate.variant.sku)) {
            acc.activeProducts.push(itemToValidate);
        }
        if (historicalProductSkus.exFreeTrialSkus.has(itemToValidate.variant.sku))
            acc.exFreeTrials.push(itemToValidate);
        return acc;
    }, { activeProducts: [], activeFreeTrials: [], exFreeTrials: [] });
};
exports.getInvalidFreeTrialLineItems = getInvalidFreeTrialLineItems;
//# sourceMappingURL=freeTrials.js.map